var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72327 0.611938C5.27467 0.611938 9.92879 3.0941 9.92879 3.0941H0C1.55137 1.54273 2.74214 0.611938 3.72327 0.611938Z",
    fill: "#716C6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7507 31.6394C34.7507 30.088 32.2686 25.4339 32.2686 25.4339L32.2686 35.3627C33.8199 33.8113 34.7507 32.6206 34.7507 31.6394Z",
    fill: "#716C6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7508 0.611938H3.7233C3.7233 0.611938 6.20549 0.922213 9.30825 3.09414C16.1343 9.60987 23.2706 16.4359 32.2686 26.0545C34.7508 29.4675 34.7508 32.2599 34.7508 32.2599V6.61194C34.7508 3.29823 32.0645 0.611938 28.7508 0.611938Z",
    fill: "#B8B1AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.769 9.24505L18.7938 7.14796L19.8744 6.13021L21.7257 8.09579L22.5859 7.28561L20.7345 5.32003L21.7831 4.33242L23.7583 6.42951L24.6895 5.55237L21.6196 2.29299L16.7678 6.86281L19.8378 10.1222L20.769 9.24505ZM21.6255 12.0202L24.5259 9.28839L24.5661 9.33105L23.507 14.0178L24.3775 14.942L29.2292 10.3721L28.2048 9.28449L25.3328 11.9896L25.296 11.9505L26.33 7.29403L25.4562 6.36633L20.6045 10.9361L21.6255 12.0202ZM30.1231 11.3212L25.2714 15.891L27.0658 17.7961C28.4786 19.2961 30.0662 19.1087 31.5769 17.6859C33.0733 16.2764 33.3471 14.744 31.9176 13.2263L30.1231 11.3212ZM30.3 13.3748L30.8122 13.9186C31.6693 14.8286 31.2666 15.7042 30.4135 16.5077C29.2157 17.6359 28.4624 17.4131 27.823 16.7342L27.3108 16.1903L30.3 13.3748Z",
    fill: "#423E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.4a4af603104431f952145d5520fa42cb.svg";
export { ForwardRef as ReactComponent };